import { LogicContext } from '@/logic/main/types';
import Cookies from '@/ports-frontend/Cookie';

export const updateIdlePopupCookie = async (context: LogicContext) => {
  const idleCookieSp = await Cookies.get('idle-popup-sp');
  const idleCookieLp = await Cookies.get('idle-popup-lp');

  return {
    idleCookieSp,
    idleCookieLp,
  };
};
